import React from "react";
import './index.scss';

const ForgotPasswordIllustrations: React.FC = () => (
  <div className="login-illustration">
    <div className="login-tagline">
      <p className="login-tagline-eyebrow">ACCOUNT RECOVERY</p>
      <h2 className="login-tagline-heading">
        Back in control<br />
        in just a few<br />
        <span className="login-tagline-accent">steps.</span>
      </h2>
      <div className="login-tagline-rule" />
      <p className="login-tagline-desc">
        We'll send a secure reset link<br />
        to your registered email.
      </p>
    </div>
  </div>
);

export default ForgotPasswordIllustrations;
